import { render, staticRenderFns } from "./step7forestry_projects_rfrp.vue?vue&type=template&id=151b8a26&scoped=true"
import script from "./step7forestry_projects_rfrp.vue?vue&type=script&lang=js"
export * from "./step7forestry_projects_rfrp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151b8a26",
  null
  
)

export default component.exports